import { useView, useRequest } from '@10000/react'
import { InputScreen, onboardBackground, useBackground, useShell, useStack } from '../../layout'
import { Avatar, Text } from '../../forms'
import { Box, H3 } from '../../widgets'
import { Teams } from '../team'
import { randomInt } from '@10000/common'

export const TeamLeadName = ({ active }) => {
  const { push } = useStack()
  const { user: { avatar = randomInt(6), name } } = useView('tenant')
  const request = useRequest('tenant')

  useBackground().set(mobile => ({ active, fade: false, ...onboardBackground(false, mobile) }))
  useShell({ active, mode: 'logo narrow' })

  const handleSetDetails = (values) => request('userUpdated', values).then(() => push(Teams))

  return (
    <InputScreen fade onSubmit={handleSetDetails} formValues={{ avatar, name }} footerButton="Join now">
      <Avatar
        name="avatar"
        size="large"
        label="TEAM LEADER"
        labelColor="white"
        labelBackground="var(--blue)"
      />

      <H3 align="center">Create your account</H3>
      <Box fullWidth gap={8} column alignItems="center">
        <Text
          title="Name"
          name="name"
          required
        />
      </Box>
    </InputScreen>
  )
}